import React from 'react';

import { useQuery } from '@sopranodesign/pulse-hooks';
import {
  PageWrapper,
  Placeholder,
  Flex,
  Divider
} from '@sopranodesign/pulse-components';

import { Scope } from './Components/index';

const groupByScope = (groups, group) => {
  return {
    ...groups,
    [group.scoped_to]: groups[group.scoped_to]
      ? groups[group.scoped_to].concat(group)
      : [group]
  };
};

const Groups = () => {
  const { data, isSuccess, isLoading } = useQuery({
    queryKey: ['groups']
  });

  const groupedTags =
    isSuccess &&
    data.data.reduce(groupByScope, {
      faqs: [],
      tickets: [],
      conversations: [],
      links: [],
      generative_ai_files: [],
      generative_ai_sitemap_urls: [],
      generative_ai_sharepoint_files: [],
      generative_ai_zendesk_articles: []
    });

  return (
    <PageWrapper header="Tags">
      {isLoading && <Placeholder ySpace />}
      {isSuccess && (
        <Flex fat="true" ySpace col>
          <Scope scope="conversations" groups={groupedTags.conversations} />
          <Divider tall />
          <Scope scope="faqs" groups={groupedTags.faqs} />
          <Divider tall />
          <Scope scope="tickets" groups={groupedTags.tickets} />
          <Divider tall />
          <Scope scope="links" groups={groupedTags.links} />
          <Divider tall />
          <Scope
            scope="generative_ai_files"
            groups={groupedTags.generative_ai_files}
          />
          <Divider tall />
          <Scope
            scope="generative_ai_sitemap_urls"
            groups={groupedTags.generative_ai_sitemap_urls}
          />
          <Divider tall />
          <Scope
            scope="generative_ai_sharepoint_files"
            groups={groupedTags.generative_ai_sharepoint_files}
          />
          <Divider tall />
          <Scope
            scope="generative_ai_zendesk_articles"
            groups={groupedTags.generative_ai_zendesk_articles}
          />
        </Flex>
      )}
    </PageWrapper>
  );
};

export default Groups;
